#!/usr/bin/env node

import { LLMail } from '../LLMail.js';
import yargs from 'yargs';
import { hideBin } from 'yargs/helpers';
import path from 'path';
import { loadLlmailConfig } from '../utils/config.js';
import { realFileSystemAdapter, RootedFileSystemAdapter } from '../utils/file-system-adapter.js';
import { PluginService } from '../services/plugin-service.js';
import { logger } from '../utils/logger.js';

async function main() {
  const argv = yargs(hideBin(process.argv))
    .usage('Usage: $0 <type> [options]')
    .option('state', {
      alias: 's',
      type: 'string',
      description: 'State of the new item',
    })
    .option('title', {
      alias: 't',
      type: 'string',
      description: 'Title for the new item (added to frontmatter)',
    })
    .option('frontmatter', {
      alias: 'f',
      type: 'string',
      description: 'JSON string representing frontmatter metadata',
    })
    .option('content', {
      alias: 'c',
      type: 'string',
      description: 'Content for the new item',
    })
    .option('config', {
      type: 'string',
      description: 'Path to llmail config file',
    })
    .demandCommand(1, 'You must provide the type of item to create')
    .help()
    .parseSync();

  // Get the positional argument 'type'
  const type = argv._[0] as string;

  // Build options object for llmail.new()
  const options: any = {};
  if (argv.state) {
    options.state = argv.state;
  }

  // Handle frontmatter: parse provided JSON and incorporate title if provided
  let frontmatter: Record<string, any> = {};
  if (argv.frontmatter) {
    try {
      frontmatter = JSON.parse(argv.frontmatter);
    } catch (err) {
      console.error('Error parsing frontmatter JSON:', err);
      process.exit(1);
    }
  }
  if (argv.title && frontmatter.title === undefined) {
    frontmatter.title = argv.title;
  }
  if (Object.keys(frontmatter).length > 0) {
    options.frontmatter = frontmatter;
  }

  if (argv.content) {
    options.content = argv.content;
  }

  // Compute rootDir from config path
  const cwd = process.cwd();
  const configPath = argv.config
    ? path.resolve(argv.config)
    : path.join(cwd, 'llmail.yaml');
  const rootDir = path.dirname(configPath);

  // Create a rooted filesystem adapter
  const fs = new RootedFileSystemAdapter(realFileSystemAdapter, rootDir);

  // Load config and initialize LLMail
  const config = await loadLlmailConfig(fs, rootDir);
  
  // Initialize LLMail with config
  const llmail = new LLMail({ fs, config, rootDir });
  await llmail.init();  // This will create and initialize the PluginService internally

  try {
    const id = await llmail.new(type, options);
    logger.success('New item created with id:', id);
  } catch (error) {
    console.error('Error creating new item:', error);
    process.exit(1);
  }
}

main(); 